import { HSLToRGB, RGBToHex } from './colorUtils';
import { hashString } from './hashString';

// Generate a set of colors based on a seed value
function generateColors(seed: number, count: number): string[] {
  const colors: string[] = [];
  const baseHue = seed * 360; // Use seed to determine base hue

  for (let i = 0; i < count; i++) {
    // Create variations around the base hue
    const hue = (baseHue + (360 / count) * i) % 360;
    
    // Increase saturation range to 85-100% for more vibrant colors
    const saturation = 85 + (seed * 15);
    
    // Adjust lightness range to 45-65% for better visibility while maintaining vibrancy
    const lightness = 45 + (((i / count) + seed) * 20);

    const rgb = HSLToRGB(hue, saturation, lightness);
    const hex = RGBToHex(rgb.r, rgb.g, rgb.b);
    colors.push(hex);
  }

  return colors;
}

export function generateGradient(name?: string | null): string {
  // Use a default string if name is undefined or null
  const safeName = name || 'default-dashboard';
  const seed = hashString(safeName);
  const colors = generateColors(seed, 3); // Generate 3 colors for the gradient
  
  // Create a unique angle based on the seed
  const angle = Math.floor(seed * 360);
  
  // Use higher opacity values for more vibrant appearance
  return `linear-gradient(${angle}deg, ${colors[0]}88 0%, ${colors[1]}aa 50%, ${colors[2]}88 100%)`;
} 